import { render, staticRenderFns } from "./CustomSensors.vue?vue&type=template&id=971e5118&lang=pug"
import script from "./CustomSensors.vue?vue&type=script&lang=js"
export * from "./CustomSensors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports